<template>
  <v-dialog persistent v-model="dialog" width="500">
    <v-card>
      <v-card-title>
        <v-layout class="mx-n2">
          <v-flex>
            <div>Edit Chat</div>
          </v-flex>
          <v-flex text-right>
            <v-btn icon @click="cancel">
              <v-icon> mdi-close </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-title>
      <v-layout class="px-4 mb-3">
        <v-flex>
          <v-layout>
            <v-flex>
              <div class="subtitle-2 mb-1">
                What's the Content of the Conversation?
              </div>
              <v-textarea
                v-model="content"
                :rules="rules"
                rows="3"
                dense
                outlined
                counter
                maxlength="200"
                placeholder="Chat Content"
              ></v-textarea>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex class="mr-1">
              <div class="subtitle-2 mb-1">Schedule At</div>
              <v-text-field
                readonly
                v-model="scheduledAtDateString"
                hide-details
                dense
                outlined
                placeholder="Scheduled Date"
                @click="openScheduleDateDialog"
              ></v-text-field>
            </v-flex>
          </v-layout>

          <v-layout class="mt-3">
            <div class="subtitle-1 font-weight-medium">Chat Options</div>
          </v-layout>

          <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Region</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="regions"
                v-model="region"
                item-text="name"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout>
          <!-- <v-layout class="mt-3">
            <v-flex>
              <div class="subtitle-2 mb-1">Entity</div>
              <v-select
                outlined
                dense
                hide-details
                return-object
                :items="reviewedEntities"
                v-model="entity"
                item-text="title"
                placeholder="Region"
              >
              </v-select>
            </v-flex>
          </v-layout> -->

          <!-- <v-layout class="mt-3">
            <v-flex xs6 class="mr-1">
              <div class="subtitle-2 mb-1">Link Name</div>
              <v-text-field
                v-model="linkName"
                hide-details
                dense
                outlined
                placeholder="Link Name"
              ></v-text-field>
            </v-flex>

            <v-flex xs6 class="ml-1">
              <div class="subtitle-2 mb-1">Link URL</div>
              <v-text-field
                v-model="linkUrl"
                hide-details
                dense
                outlined
                placeholder="Ex: http://..."
              ></v-text-field>
            </v-flex>
          </v-layout> -->

          <gallery-image-select-section
            v-if="state === 'scheduled' || state === 'updated'"
            ref="galleryImageSelectSectionRef"
            @imageSelected="galleryImageSelected"
          />

          <v-layout v-if="imageUrl && !selectedFromGallery" class="mt-3">
            <v-flex xs4>
              <v-card>
                <v-img
                  gradient="to top left, rgba(0,0,0,0), rgba(0,0,0,.7)"
                  aspect-ratio="1"
                  :lazy-src="imageUrl"
                  :src="imageUrl"
                >
                  <v-layout v-if="state === 'scheduled' || state === 'updated'">
                    <v-btn icon small @click="galleryImageSelected({})">
                      <v-icon color="white"> mdi-close </v-icon>
                    </v-btn>
                  </v-layout>
                </v-img>
              </v-card>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="cancel"
          color="error"
          class="text-none subtitle-2"
          outlined
        >
          Cancel
        </v-btn>
        <v-btn color="primary" class="text-none subtitle-2" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
    <time-and-date-select-dialog
      @onDateSelected="onScheduleDateSelected"
      ref="ScheduleTimeAndDateDialogRef"
    />
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import firebase from 'firebase';
import _ from 'lodash';
import { auth } from '@/plugins/firebase';
import moment from 'moment';
import TimeAndDateSelectDialog from './TimeAndDateSelectDialog.vue';
//import ImageUploadSection from "./ImageUploadSection";
import GalleryImageSelectSection from '@/modules/Assets/components/GalleryImageSelectSection';
export default {
  props: {
    selectedRegion: {
      type: Object,
      default: function() {
        return {};
      },
    },
    collection: {
      type: String,
      default: function() {
        return {};
      },
    },
  },
  components: {
    TimeAndDateSelectDialog,
    GalleryImageSelectSection,
    // ImageUploadSection,
  },
  data() {
    return {
      dialog: false,
      hasCustomLocation: false,
      rules: [(v) => v.length <= 150 || 'Max 150 characters'],
      selectedFromGallery: false,
      searchTerm: '',
      loading: false,
      dialogAction: '',
      scheduleDateDialog: false,
      expiryDateDialog: false,
      scheduledAtDateField: '',
      expiresAtDateField: '',
      scheduledAt: '',
      expiresAt: '',
      region: {},

      createdBy: '',
      content: '',

      isMarker: false,
      location: {},
      firebaseUrl: '',
      imageThumbnail: '',
      imageUrl: '',
      state: '',

      id: '',
      //   linkName: "",
      //   linkUrl: "",
      score: Number(0),
      originalImage: {},
      totalComments: Number(0),
      views: Number(0),
    };
  },
  computed: {
    ...mapState('$_home', ['regions']),
    ...mapGetters({
      chatTypes: '$_home/chatTypes',
    }),
    scheduledAtDateString() {
      if (this.scheduledAtDateField) {
        return this.iMoment(this.scheduledAtDateField);
      } else {
        return this.scheduledAt;
      }
    },

    changeFieldsCopy() {
      return {
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: 'scheduled',

        type: 'conversation',
        region: this.region,
        createdBy: {
          id: auth.currentUser.uid,
          email: auth.currentUser.email,
          name: auth.currentUser.displayName,
        },

        data: {
          content: this.content,
          createdBy: auth.currentUser.uid,

          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude),
          ),

          score: Number(0),

          totalComments: Number(0),
          type: 'conversation',
          views: Number(0),
        },
      };
    },

    changeFields() {
      return {
        id: this.id,
        scheduledAt: this.iMoment(this.scheduledAtDateField),
        state: this.state,

        type: 'conversation',
        region: this.region,

        data: {
          content: this.content,
          createdBy: auth.currentUser.uid,

          image: this.imageUrl
            ? {
                firebaseUrl: this.firebaseUrl,
                thumbnail: this.imageThumbnail,
                url: this.imageUrl,
              }
            : null,
          link: this.linkUrl
            ? {
                url: this.linkUrl,
                name: this.linkName,
              }
            : null,
          isMarker: this.isMarker,
          location: new firebase.firestore.GeoPoint(
            parseFloat(this.region.latitude),
            parseFloat(this.region.longitude),
          ),

          score: this.score,

          totalComments: this.totalComments,
          type: 'conversation',
          views: this.views,
        },
      };
    },
  },

  mounted() {
    this.getRegions({ collection: 'regions', mutation: 'updateRegions' });
    // this.getEntityTypes({
    //   collection: "entityTypes",
    //   mutation: "updateEntityTypes",
    // });
  },
  methods: {
    ...mapActions({
      createNewChat: '$_content/createNewContent',
      updateChat: '$_content/updateContent',
      uploadImage: '$_content/uploadImage',
      getRegions: '$_home/getContent',

      getChats: '$_content/getContent',
      getChatsByRegion: '$_content/getContentByRegion',
    }),

    iMoment(date) {
      if (date) {
        // console.log(date);
        return moment(date).toDate();
      }
      return new Date();
    },
    toggleDialog(details, action) {
      this.dialog = !this.dialog;
      if (this.dialog) {
        console.log('Edit Details: ', details);
        this.dialogAction = action;
        this.id = details.id;
        this.scheduledAtDateField = details.scheduledAt
          ? details.scheduledAt.seconds * 1000
          : '';

        this.scheduledAt = this.iMoment(details.scheduledAt.seconds * 1000);

        this.state = details.state;
        this.region = details.region;

        this.createdBy = details.createdBy;
        this.content = details.data.content;

        this.originalImage = details.data.image;
        this.imageThumbnail = details.data.image
          ? details.data.image.thumbnail
          : '';
        this.firebaseUrl = details.data.image
          ? details.data.image.firebaseUrl
            ? details.data.image.firebaseUrl
            : ''
          : '';
        this.imageUrl = details.data.image ? details.data.image.url : '';
        this.score = details.data.score;
        this.totalComments = details.data.totalComments;
        this.views = details.data.views;
        this.linkUrl = details.data.link ? details.data.link.url : '';
        this.linkName = details.data.link ? details.data.link.name : '';
        this.location = details.data.location;
      }
    },
    openExpiryDateDialog() {
      this.$refs.ExpiryTimeAndDateDialogRef.toggleDialog(
        this.expiresAtDateField,
      );
    },
    onExpiryDateSelected(dateTime) {
      // console.log("Expiry Selected Date and Time: ", dateTime);
      this.expiresAtDateField = dateTime;
    },
    openScheduleDateDialog() {
      this.$refs.ScheduleTimeAndDateDialogRef.toggleDialog(
        this.scheduledAtDateField,
      );
    },
    onScheduleDateSelected(dateTime) {
      // console.log("Scheduled Selected Date and Time: ", dateTime);
      this.scheduledAtDateField = dateTime;
    },
    galleryImageSelected(image) {
      this.selectedFromGallery = image ? true : false;
      this.imageUrl = image.url;
      this.firebaseUrl = image.firebaseUrl ? image.firebaseUrl : '';
      this.imageThumbnail = image.thumbnail;
    },
    cancel() {
      this.scheduledAtDateField = '';
      this.expiresAtDateField = '';
      this.scheduledAt = '';

      this.state = '';
      this.region = {};

      this.createdBy = '';
      this.content = '';

      this.isMarker = false;
      this.location = {};
      this.imageThumbnail = '';
      this.imageUrl = '';

      this.id = '';
      if (this.selectedFromGallery == true) {
        this.$refs.galleryImageSelectSectionRef.galleryImageDeselect();
      }
      this.selectedFromGallery = false;

      this.dialog = false;
    },
    save() {
      console.log(this.changeFields);
      if (!this.scheduledAtDateString) {
        alert('Yo yo, Slow down dude, add a Scheduled At time');
        return;
      }
      if (this.dialogAction === 'copy') {
        this.createNewChat({
          details: this.changeFieldsCopy,
          collection: this.collection,
          type: 'Conversation',
        }).then(() => {
          this.cancel();
          this.getChatsByRegion({
            type: 'conversation',
            collection: this.collection,
            mutation: 'updateChats',
            region: this.selectedRegion,
          });
        });
      } else {
        this.updateChat({
          details: this.changeFields,
          collection: this.collection,
          type: 'Conversation',
        }).then(() => {
          this.cancel();
          this.getChatsByRegion({
            type: 'conversation',
            collection: this.collection,
            mutation: 'updateChats',
            region: this.selectedRegion,
          });
        });
      }
    },
  },
};
</script>

<style></style>
